import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/rentPaymentTypeList',
        method: 'post',
        data: {
            ...params,
            current,
            size
        }
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductManagement/editUpdate',
        method: 'post',
        data: row
    })
}